import { render, staticRenderFns } from "./CvsStoreItem.vue?vue&type=template&id=7327d128&scoped=true&"
import script from "./CvsStoreItem.vue?vue&type=script&lang=js&"
export * from "./CvsStoreItem.vue?vue&type=script&lang=js&"
import style0 from "./CvsStoreItem.vue?vue&type=style&index=0&id=7327d128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327d128",
  null
  
)

export default component.exports